import styled, { css } from 'styled-components'
import {
  InputMultipleNumbersWrapperProps,
  InputMultipleNumbersSectionWrapperProps,
} from './types'
import { FontStyle } from '../../Core/Typography/Font/Font.styles'
import { InputProps } from '../Input/types'

export const InputMultipleNumbersWrapper = styled(
  'div'
)<InputMultipleNumbersWrapperProps>`
  width: 100%;
  min-width: 100px;
  min-height: ${props => props.minHeight || '84px'};
  margin-bottom: 8px;
  user-select: none;
  ${props =>
    props.gridArea &&
    css`
      grid-area: ${props.gridArea};
    `}
  ${props =>
    props.wrapperPadding &&
    css`
      padding: ${props.wrapperPadding};
    `}
`

export const InputStyle = styled('input')<InputProps>`
  appearance: none;
  padding: 8px 6px;
  background-color: ${props => props.theme.colors.main.background};
  border: 1px solid transparent;
  border-right-color: ${props => props.theme.colors.shades.neutral[1]};
  width: 12px;
  height: 14px;
  font-size: 14px;
  font-family: ${props => props.theme.font.family[0]};
  text-align: center;
`
export const InputMultipleNumbersSectionMainWrapper = styled.div`
  display: flex;
  flex-direction: row;
  appearance: none;
  margin: 4px 0 8px 0;
`

export const InputMultipleNumbersSectionWrapper = styled.div<InputMultipleNumbersSectionWrapperProps>`
  display: flex;
  flex-direction: row;
  appearance: none;
  background-color: ${props => props.theme.colors.main.background};
  outline: 1px solid ${props => props.theme.colors.shades.neutral[1]};
  border-radius: 4px;
  height: 30px;
  font-size: 12px;
  font-family: ${props => props.theme.font.family[0]};

  ${props =>
    props.error &&
    css`
      outline: 1px solid ${props => props.theme.colors.main.error};
    `}

  & ${InputStyle}:last-of-type {
    border-right-color: transparent;
  }

  & ${InputStyle} {
    &:hover {
      border: 1px solid ${props => props.theme.colors.shades.neutral[2]};
      :first-of-type {
        border-radius: 4px 0 0 4px;
      }
      :last-of-type {
        border-radius: 0 4px 4px 0;
      }
    }

    &:focus {
      border: 1px solid ${props => props.theme.colors.main.ultraViolet};
      :first-of-type {
        border-radius: 4px 0 0 4px;
      }
      :last-of-type {
        border-radius: 0 4px 4px 0;
      }
    }

    &:focus-visible {
      outline: none;
    }

    &:disabled {
      background-color: ${props => props.theme.colors.shades.neutral[0]};
      :first-of-type {
        border-radius: 4px 0 0 4px;
      }
      :last-of-type {
        border-radius: 0 4px 4px 0;
      }
    }
  }
`

export const NumSectionSeparator = styled.span`
  margin: 2px 6px 0 6px;
`

export const ErrorLabel = styled(FontStyle).attrs({
  as: 'h6',
  tag: 'h6',
  ellipsis: true,
  bold: true,
})`
  color: ${props => props.theme.colors.main.error};
`
